import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import GroupPicker from './view/index.tsx';

export default ComponentWithAnalytics('GroupPicker', {
	onChange: 'changed',
})(GroupPicker);
